exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul.listarefs {\n  list-style: none;\n  padding-left: 0px !important;\n}\n", ""]);

// exports
